module.exports = __webpack_public_path__ + "img/caconde.589ced43.png";